export const CHECKOUT_PAGE = "CHECKOUT_PAGE";
